import { createContext, useContext, useState } from "react";
import {
  emptyAnunciosFilters,
  type AnunciosFilters,
} from "@/components/admin/AnunciosFiltersSheet";

const Ctx = createContext<{
  filters: AnunciosFilters;
  setFilters: (f: AnunciosFilters) => void;
  open: boolean;
  setOpen: (v: boolean) => void;
} | null>(null);

export function AnunciosFiltersProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [filters, setFilters] = useState<AnunciosFilters>(emptyAnunciosFilters);
  const [open, setOpen] = useState(false);
  return (
    <Ctx.Provider value={{ filters, setFilters, open, setOpen }}>
      {children}
    </Ctx.Provider>
  );
}

const noopFilters = {
  filters: emptyAnunciosFilters,
  setFilters: () => {},
  open: false,
  setOpen: () => {},
};

export function useAnunciosFilters() {
  const v = useContext(Ctx);
  return v ?? noopFilters;
}
